/* Moved from sections/hlth-berberine-benefits-timeline.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(SID) {
      (function() {
        var timeline = document.getElementById('hlth-bbt-timeline-' + SID + '');
        if (!timeline) return;
        var progress = document.getElementById('hlth-bbt-progress-' + SID + '');
        var items = timeline.querySelectorAll('[data-bbt-item]');
        if (!items.length) return;

        /* Compute line bounds so the grey/progress line runs from first dot center to last dot center */
        function lineBounds() {
          var firstItem = items[0];
          var lastItem = items[items.length - 1];
          /* Dot: 30px mobile (halfDot 15, top 2), 34px tablet+ (halfDot 17, top 4) */
          var isTablet = window.innerWidth >= 750;
          var halfDot = isTablet ? 17 : 15;
          var dotTopOffset = isTablet ? 4 : 2;
          var top = firstItem.offsetTop + dotTopOffset + halfDot;
          var bottom = lastItem.offsetTop + dotTopOffset + halfDot;
          return { top: top, height: Math.max(0, bottom - top) };
        }

        function positionLine() {
          var b = lineBounds();
          timeline.style.setProperty('--bbt-line-top', b.top + 'px');
          timeline.style.setProperty('--bbt-line-height', b.height + 'px');
        }

        positionLine();
        window.addEventListener('resize', positionLine);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          items.forEach(function(item) { item.classList.add('is-active'); });
          progress.style.height = lineBounds().height + 'px';
          return;
        }

        function initTimeline() {
          if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
            items.forEach(function(item) { item.classList.add('is-active'); });
            progress.style.height = lineBounds().height + 'px';
            return;
          }

          gsap.registerPlugin(ScrollTrigger);
          var lastItem = items[items.length - 1];

          ScrollTrigger.create({
            trigger: timeline,
            start: 'top 70%',
            end: function() { return '+=' + (lastItem.offsetTop + lastItem.offsetHeight); },
            scrub: 1.2,
            onUpdate: function(self) {
              var maxH = lineBounds().height;
              gsap.set(progress, { height: Math.round(maxH * self.progress) });
            }
          });

          items.forEach(function(item) {
            ScrollTrigger.create({
              trigger: item,
              start: 'top 75%',
              once: true,
              onEnter: function() { item.classList.add('is-active'); }
            });
          });
        }

        if (document.readyState === 'loading') {
          (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initTimeline) : initTimeline());
        } else {
          initTimeline();
        }

        document.addEventListener('shopify:section:load', function() {
          positionLine();
          if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
        });
      })();
  }
  function scan(scope) {
    var list = [];
    if (scope.classList && scope.classList.contains('hlth-s--hlth-berberine-benefits-timeline')) list.push(scope);
    scope.querySelectorAll('.hlth-s--hlth-berberine-benefits-timeline').forEach(function (w) { list.push(w); });
    list.forEach(function (w) {
      if (w.__hlthJs_hlth_berberine_benefits_timeline) return;
      w.__hlthJs_hlth_berberine_benefits_timeline = true;
      run(w.id.replace(/^shopify-section-/, ''));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
